module.exports = __webpack_public_path__ + "img/article.2a7f025d.svg";